/**
 * シード付き乱数生成ユーティリティ
 *
 * 同じシードから同じ乱数列を生成することで、
 * 同日・同商人で同じ品揃えを再現可能にする
 */

/**
 * シード付き乱数生成器（Mulberry32アルゴリズム）
 * @param seed 初期シード値
 * @returns 0-1の乱数を返す関数
 */
export function createSeededRandom(seed: number): () => number {
  let state = seed >>> 0; // 符号なし32ビット整数に変換
  return () => {
    state = (state + 0x6D2B79F5) >>> 0;
    let t = Math.imul(state ^ (state >>> 15), state | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

/**
 * 文字列からハッシュ値を生成（djb2アルゴリズム）
 * @param str 入力文字列
 * @returns ハッシュ値
 */
export function hashString(str: string): number {
  let hash = 5381;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = ((hash << 5) + hash) + char; // hash * 33 + char
    hash = hash >>> 0; // 符号なし32ビットに変換
  }
  return hash;
}

/**
 * 日付+商人名からシードを生成（全ユーザー共通）
 * @param dayId ゲーム内の日数
 * @param merchantName 商人名
 * @returns シード値
 */
export function getDailyMerchantSeed(dayId: number, merchantName: string): number {
  return hashString(`${merchantName}:${dayId}`);
}

/**
 * ユーザー+日付+商人名からシードを生成（ユーザー固有）
 * 旅商人や闇商人など、ユーザーごとに異なる品揃え・価格を提供する場合に使用
 * @param userId ユーザーID
 * @param dayId ゲーム内の日数
 * @param merchantName 商人名
 * @returns シード値
 */
export function getUserMerchantSeed(userId: string, dayId: number, merchantName: string): number {
  return hashString(`${userId}:${merchantName}:${dayId}`);
}
